import { FreePlacesValue, MaximumStayValue } from 'ha/types/SearchFilters';
import { Filters } from '../types';

export function getFilterTagsCount({
  types,
  rooms,
  price,
  facilities,
  gender,
  freePlaces,
  maximumStay,
  registration,
}: Filters): number {
  return (
    (types ? types.length : 0) +
    (rooms ? rooms.bedroomCount.length : 0) +
    (facilities ? facilities.length : 0) +
    (registration && registration.length > 0 ? 1 : 0) +
    (price ? price.length : 0) +
    (gender ? gender.length : 0) +
    (freePlaces && freePlaces !== FreePlacesValue.ZERO ? 1 : 0) +
    (maximumStay && maximumStay !== MaximumStayValue.ZERO ? 1 : 0)
  );
}
